
export const homequestionData = [
  {
    id: 1,
    header: "রিভাইভ টেস্ট কী?",
    text: "টেস্ট রিপোর্ট থেকে আপনার সন্তানের মস্তিষ্কের চিন্তাশক্তি, চিন্তার ধরন ও বিশ্বাস, শিক্ষাগত দুর্বলতা এবং শারীরিক সুস্থতা বুঝতে পারবেন, যাতে সঠিক দিকনির্দেশনা দেওয়া যায়।",
  },
  {
    id: 2,
    header: "কোন বয়সের শিশুরা রিভাইভ টেস্ট দিতে পারে?",
    text: "সাধারণত ৭ থেকে ১৬ বছর বয়সী শিশুরা এই টেস্টে অংশ নিতে পারে।",
  },
  {
    id: 3,
    header: "এই টেস্ট কী অনলাইনে দেওয়া যায়?",
    text: "হ্যাঁ, QS Academy তে আপনি রিভাইভ টেস্ট অনলাইনে সম্পূর্ণ করতে পারবেন।",
  },
  {
    id: 4,
    header: "REVIVE টেস্টের সময় কত মিনিট ?",
    text: "এই টেস্টটি করতে সময় লাগবে ৩০ মিনিট",
  },
  {
    id: 5,
    header: "QS স্মার্ট স্কুল Franchise এর সুবিধা কী কী?",
    text: "আধুনিক SMART কারিকুলাম, ডিজিটাল ক্লাস, শিক্ষকের প্রশিক্ষণ, স্মার্ট লার্নিং, হোলিস্টিক ডেভেলপমেন্ট ও একটি সম্পূর্ণ সাপোর্ট সিস্টেম।",
  },
  {
    id: 6,
    header: "আমি কীভাবে একটি QS Smart School খুলতে পারি?",
    text: "QS Academy-র ফ্র্যাঞ্চাইজি মডেলে আবেদন করে আপনি আপনার এলাকায় একটি স্মার্ট স্কুল খুলতে পারেন।",
  },
];


export const thoughtQuestionData = [
  {
    id: 1,
    header: "Children Mapping Thought Test কী?",
    text: [
      "Children Mapping Thought Test হলো একটি আধুনিক মানসিক মূল্যায়ন পদ্ধতি, যার মাধ্যমে শিশুর চিন্তার গঠন, বিশ্লেষণ ক্ষমতা, যুক্তির ধারা এবং শেখার প্যাটার্ন ম্যাপ করে বোঝা যায় সে কীভাবে চিন্তা করে।",
    ],
  },
  {
    id: 2,
    header: "এই টেস্টের মূল উদ্দেশ্য কী?",
    text: [
      "মূল উদ্দেশ্য হলো শিশুর চিন্তাভাবনার ধরণ (Thought Pattern) বুঝে তার জন্য একটি ব্যক্তিকেন্দ্রিক শেখার পদ্ধতি ও মানসিক বিকাশের রূপরেখা তৈরি করা।",
    ],
  },
  {
    id: 3,
    header: "এই টেস্টে কী কী বিশ্লেষণ করা হয়?",
    text: [
      "শিশুর যুক্তিভিত্তিক চিন্তাভাবনা",
      "কল্পনাশক্তি ও সৃজনশীলতা",
      "সমস্যা সমাধানের পদ্ধতি",
      "তথ্য সংযোগ ও ধারণা তৈরি করার দক্ষতা",
      "শেখার স্টাইল (Visual / Logical / Verbal)",
    ],
  },
  {
    id: 4,
    header: "কোন বয়সের শিশুরা এই টেস্ট দিতে পারে?",
    text: ["৬ থেকে ১৬ বছর বয়সী যেকোনো শিশু এই টেস্টে অংশ নিতে পারে।"],
  },
  {
    id: 5,
    header: "টেস্টটি কীভাবে নেওয়া হয়?",
    text: [
      "এই টেস্টটি সাধারণত ইন্টারঅ্যাকটিভ প্রশ্ন, চার্ট, ম্যাপিং টাস্ক, এবং বিশ্লেষণমূলক প্রশ্নের মাধ্যমে নেওয়া হয় — অনলাইনে বা অফলাইনে উভয়ভাবেই।",
    ],
  },
  {
    id: 6,
    header: "Mapping Thought Test এর ফলাফল কীভাবে উপকারে আসে?",
    text: [
      "ফলাফলের মাধ্যমে জানা যায় শিশুর শক্তি ও দুর্বলতা কোথায়, সে কোনভাবে শিখতে বেশি সুবিধা পায়, এবং তার মানসিক দিক থেকে কোন উন্নতি প্রয়োজন।",
    ],
  },
  {
    id: 7,
    header: "এই টেস্ট কি শুধুই দুর্বল শিক্ষার্থীদের জন্য?",
    text: [
      "না, এটি যেকোনো শিশুর জন্য উপকারী — বিশেষ করে যারা আরও ভালোভাবে শেখার উপায় খুঁজছে বা নিজের সম্ভাবনা জানতে চায়।",
    ],
  },
  {
    id: 8,
    header: "এই টেস্টের রিপোর্টে কী থাকে?",
    text: [
      "চিন্তার ধরণ অনুযায়ী বিশ্লেষণ",
      "শেখার উপযোগী পদ্ধতির সুপারিশ",
      "Cognitive Skill স্কোর",
      "যুক্তি, স্মৃতি ও বিশ্লেষণ ক্ষমতার রেটিং",
      "অভিভাবকের জন্য দিকনির্দেশনা",
    ],
  },
  {
    id: 9,
    header: "কীভাবে এই রিপোর্ট ব্যবহার করা যায়?",
    text: [
      "রিপোর্টের উপর ভিত্তি করে অভিভাবক ও শিক্ষক শিশুর জন্য উপযুক্ত স্টাডি প্ল্যান, মোটিভেশন টেকনিক ও মানসিক বিকাশের কৌশল নির্ধারণ করতে পারেন।",
    ],
  },
  {
    id: 10,
    header: "এই টেস্টের সাথে কি কাউন্সেলিং সুবিধা পাওয়া যায়?",
    text: [
      "হ্যাঁ, QS Academy-তে এই টেস্টের পরে একটি One-on-One Parent Counseling সেশন দেওয়া হয়, যেখানে রিপোর্ট ব্যাখ্যা ও উন্নয়নের রোডম্যাপ তুলে ধরা হয়।",
    ],
  },
];


export const physicalWellnessData = [
  {
    id: 1,
    header: "Physical Wellness Test কী?",
    text: [
      "Physical Wellness Test হল একটি স্বাস্থ্য মূল্যায়ন প্রক্রিয়া, যার মাধ্যমে শিশুর দেহগত সুস্থতা, খাওয়া-দাওয়ার অভ্যাস, ঘুম, ব্যায়াম, শক্তি ও দৈহিক ফিটনেস পর্যবেক্ষণ করা হয়।",
    ],
  },
  {
    id: 3,
    header: "এই টেস্টে কী কী বিষয় পরীক্ষা করা হয়?",
    text: [
      "উচ্চতা ও ওজনের ভারসাম্য (BMI)",
      "ঘুমের গুণগত মান",
      "খাদ্যাভ্যাস",
      "দৈনন্দিন শারীরিক সক্রিয়তা",
      "ক্লান্তি বা অবসাদ অনুভবের হার",
      "অঙ্গভঙ্গি ও ফিটনেস লেভেল",
    ],
  },
  {
    id: 4,
    header: "কোন বয়সের শিশুরা এই টেস্ট দিতে পারে?",
    text: [
      "সাধারণত ৫ থেকে ১৬ বছর বয়সী শিশুরা Physical Wellness Test দিতে পারে।",
    ],
  },
  {
    id: 5,
    header: "এই টেস্টটি কে পরিচালনা করেন?",
    text: [
      "QS Academy-র প্রশিক্ষিত স্বাস্থ্য মূল্যায়নকারী ও সুস্থতা পরামর্শদাতা (Wellness Coach) এই টেস্ট পরিচালনা করেন।",
    ],
  },
  {
    id: 6,
    header: "এই টেস্টের ফলাফল কীভাবে সাহায্য করে?",
    text: [
      "ফলাফলের ভিত্তিতে শিশুর জন্য একটি স্বাস্থ্যকর জীবনযাপনের রুটিন, সঠিক খাদ্যাভ্যাস ও ব্যায়াম পরিকল্পনা দেওয়া হয়।",
    ],
  },
  {
    id: 8,
    header: "টেস্টের রিপোর্টে কী কী তথ্য থাকে?",
    text: [
      "শারীরিক ফিটনেস স্কোর",
      "নিউট্রিশন রেটিং",
      "ঘুম ও বিশ্রামের মান",
      "সুপারিশকৃত ডায়েট প্ল্যান",
      "স্বাস্থ্যকর অভ্যাসের তালিকা",
    ],
  },
  {
    id: 9,
    header: "টেস্টের পরে কাউন্সেলিং হয় কি?",
    text: [
      "হ্যাঁ, প্রতিটি Physical Wellness Test-এর পর অভিভাবক ও শিশুকে স্বাস্থ্য নির্দেশনা এবং প্রয়োজনীয় কাউন্সেলিং প্রদান করা হয়।",
    ],
  },
  {
    id: 10,
    header: "Physical Wellness Test কি অনলাইনে সম্ভব?",
    text: [
      "বেসিক ফিডব্যাক অনলাইনে পাওয়া গেলেও সম্পূর্ণ নির্ভুল ফলাফল পেতে অফলাইন অ্যাসেসমেন্টই অধিক কার্যকর।",
    ],
  },
];


export const mindMappingTestData = [
  {
    id: 1,
    header: "Mind Mapping Test কী?",
    text: [
      "Mind Mapping Test একটি সৃজনশীল মূল্যায়ন পদ্ধতি, যা শিশুর চিন্তাভাবনা, আইডিয়া তৈরি, তথ্য সংযোগ এবং শেখার কৌশল কেমন তা বিশ্লেষণ করে।",
    ],
  },
  {
    id: 2,
    header: "এই টেস্ট কীভাবে কাজ করে?",
    text: [
      "এই টেস্টে শিশুকে একটি নির্দিষ্ট বিষয়ে তার চিন্তাধারা চিত্র আকারে সাজাতে বলা হয় (Mind Map)। এরপর তা বিশ্লেষণ করে তার বিশ্লেষণ ক্ষমতা, সৃজনশীলতা এবং শেখার ধরন নির্ধারণ করা হয়।",
    ],
  },
  {
    id: 3,
    header: "Mind Map বলতে কী বোঝায়?",
    text: [
      "Mind Map হলো একটি গ্রাফিক্যাল চিন্তার মানচিত্র, যেখানে একটি মূল আইডিয়াকে কেন্দ্র করে নানা উপ-আইডিয়া, যুক্তি বা উদাহরণ শাখা-প্রশাখার মতো ছড়িয়ে দেওয়া হয়।",
    ],
  },
  {
    id: 4,
    header: "এই টেস্ট শিশুর জন্য কতটা উপকারী?",
    text: [
      "Mind Mapping Test শিশুর মস্তিষ্কের গঠন ও তথ্য সংরক্ষণ পদ্ধতি বুঝতে সাহায্য করে। এটি শেখার আগ্রহ বাড়ায়, স্মৃতিশক্তি উন্নত করে, ও সমস্যা সমাধানের দক্ষতা তৈরি করে।",
    ],
  },
  {
    id: 5,
    header: "কোন বয়সের শিশুরা এই টেস্ট দিতে পারে?",
    text: [
      "৭ থেকে ১৬ বছর বয়সী যেকোনো শিশু এই টেস্ট দিতে পারে।",
    ],
  },
  {
    id: 6,
    header: "এই টেস্টের মাধ্যমে কী ধরনের দক্ষতা যাচাই হয়?",
    text: [
      "যুক্তিভিত্তিক চিন্তাভাবনা",
      "আইডিয়া সংগঠনের ক্ষমতা",
      "সৃজনশীলতা",
      "তথ্য সংযোগ ও প্রক্রিয়াজাতকরণ",
      "দৃশ্যমান শেখার দক্ষতা (Visual Learning)",
    ],
  },
  {
    id: 7,
    header: "Mind Mapping Test কি শুধু শিক্ষার্থীদের জন্য?",
    text: [
      "মূলত শিক্ষার্থীদের জন্য হলেও শিক্ষকরাও এতে উপকৃত হন, কারণ এটি শিক্ষার্থীর শেখার স্টাইল বুঝতে সাহায্য করে।",
    ],
  },
  {
    id: 8,
    header: "এই টেস্টে কী ধরনের রিপোর্ট পাওয়া যায়?",
    text: [
      "শিশুর চিন্তার ধরন অনুযায়ী বিশ্লেষণ",
      "সৃজনশীলতা ও বিশ্লেষণ দক্ষতার স্কোর",
      "শিখন শৈলী (Learning Style) শনাক্তকরণ",
      "মানসিকভাবে উপযুক্ত শেখার কৌশলের পরামর্শ",
    ],
  },
  {
    id: 9,
    header: "এই টেস্ট কীভাবে শিশুর পড়াশোনায় সাহায্য করে?",
    text: [
      "Mind Mapping-এর মাধ্যমে জটিল তথ্য সহজে মনে রাখা যায়। পরীক্ষার প্রস্তুতি, প্রজেক্ট প্ল্যানিং এবং রিভিশনের জন্য এটি একটি দারুণ কৌশল।",
    ],
  },
  {
    id: 10,
    header: "এই টেস্টের সাথে কী কোনো প্রশিক্ষণ বা গাইডলাইন পাওয়া যায়?",
    text: [
      "হ্যাঁ, QS Academy-তে Mind Mapping Test-এর পর শিশু ও অভিভাবকদের জন্য Visual Learning গাইডলাইন এবং কাস্টমাইজড স্টাডি টিপস প্রদান করা হয়।",
    ],
  },
];